module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0039.jpg?v=51ef5099";